import {
  smediasState
} from "./smedias.state";
import {
  smediasActions
} from "./smedias.actions";
import {
  smediasGetters
} from "./smedias.getters";
import {
 smediasMutations
} from "./smedias.mutations";

export default {
  state: smediasState,
  actions: smediasActions,
  getters: smediasGetters,
  mutations: smediasMutations
};